import { onDocumentLoaded } from '@theme/utilities';

const WEATHER_URL = 'https://api.open-meteo.com/v1/forecast';

const WEATHER_CODE_MAP = {
  0: { label: 'Clear', icon: 'sun' },
  1: { label: 'Mostly clear', icon: 'sun-cloud' },
  2: { label: 'Partly cloudy', icon: 'sun-cloud' },
  3: { label: 'Overcast', icon: 'cloud' },
  45: { label: 'Fog', icon: 'fog' },
  48: { label: 'Fog', icon: 'fog' },
  51: { label: 'Light drizzle', icon: 'drizzle' },
  53: { label: 'Drizzle', icon: 'drizzle' },
  55: { label: 'Heavy drizzle', icon: 'drizzle' },
  56: { label: 'Freezing drizzle', icon: 'drizzle' },
  57: { label: 'Freezing drizzle', icon: 'drizzle' },
  61: { label: 'Light rain', icon: 'rain' },
  63: { label: 'Rain', icon: 'rain' },
  65: { label: 'Heavy rain', icon: 'rain' },
  66: { label: 'Freezing rain', icon: 'rain' },
  67: { label: 'Freezing rain', icon: 'rain' },
  71: { label: 'Light snow', icon: 'snow' },
  73: { label: 'Snow', icon: 'snow' },
  75: { label: 'Heavy snow', icon: 'snow' },
  77: { label: 'Snow grains', icon: 'snow' },
  80: { label: 'Rain showers', icon: 'rain' },
  81: { label: 'Rain showers', icon: 'rain' },
  82: { label: 'Heavy showers', icon: 'rain' },
  85: { label: 'Snow showers', icon: 'snow' },
  86: { label: 'Snow showers', icon: 'snow' },
  95: { label: 'Thunderstorm', icon: 'storm' },
  96: { label: 'Storm and hail', icon: 'storm' },
  99: { label: 'Storm and hail', icon: 'storm' },
};

function getIconMarkup(icon) {
  switch (icon) {
    case 'cloud':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 18h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 6.17 8.4 3.75 3.75 0 0 0 7 18Z"></path>
        </svg>`;
    case 'fog':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 10a4 4 0 0 1 7.53-1.82A3.5 3.5 0 1 1 16 15H7"></path>
          <path d="M4 17h10"></path>
          <path d="M10 20h8"></path>
        </svg>`;
    case 'drizzle':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 14h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 6.17 4.4 3.75 3.75 0 0 0 7 14Z"></path>
          <path d="M8 18h.01"></path>
          <path d="M12 20h.01"></path>
          <path d="M16 18h.01"></path>
        </svg>`;
    case 'rain':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 13.5h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 6.17 3.9 3.75 3.75 0 0 0 7 13.5Z"></path>
          <path d="M9 17l-1 3"></path>
          <path d="M13 17l-1 3"></path>
          <path d="M17 17l-1 3"></path>
        </svg>`;
    case 'snow':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 13.5h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 6.17 3.9 3.75 3.75 0 0 0 7 13.5Z"></path>
          <path d="M9 16v4"></path>
          <path d="M7.5 17.5 10.5 19"></path>
          <path d="M7.5 19 10.5 17.5"></path>
          <path d="M15 16v4"></path>
          <path d="M13.5 17.5 16.5 19"></path>
          <path d="M13.5 19 16.5 17.5"></path>
        </svg>`;
    case 'storm':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 13.5h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 6.17 3.9 3.75 3.75 0 0 0 7 13.5Z"></path>
          <path d="m12 14-2 4h3l-1 4 4-6h-3l1-2"></path>
        </svg>`;
    case 'sun-cloud':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 5V3"></path>
          <path d="m18.24 7.76 1.42-1.42"></path>
          <path d="M20 12h2"></path>
          <path d="M7 18h9a4 4 0 0 0 .4-7.98A5.5 5.5 0 0 0 8.5 7.5"></path>
          <path d="M10 6.5A3.5 3.5 0 1 0 10 13"></path>
        </svg>`;
    case 'sun':
    default:
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2.5"></path>
          <path d="M12 19.5V22"></path>
          <path d="M4.93 4.93l1.77 1.77"></path>
          <path d="M17.3 17.3l1.77 1.77"></path>
          <path d="M2 12h2.5"></path>
          <path d="M19.5 12H22"></path>
          <path d="M4.93 19.07l1.77-1.77"></path>
          <path d="M17.3 6.7l1.77-1.77"></path>
        </svg>`;
  }
}

function updateWidget(widget, weather) {
  const temperature = widget.querySelector('.header-weather__temperature');
  const icon = widget.querySelector('.header-weather__icon');
  const label = widget.querySelector('.header-weather__label');

  if (!temperature || !icon || !label) return;

  const code = Number(weather.weather_code);
  const config = WEATHER_CODE_MAP[code] ?? WEATHER_CODE_MAP[0];
  const roundedTemp = Math.round(Number(weather.temperature_2m));
  const location = widget.dataset.location || 'Bethlehem, PA';

  temperature.innerHTML = `${roundedTemp}&deg;F`;
  icon.innerHTML = getIconMarkup(config.icon);
  label.textContent = `${config.label} near ${location}`;
  widget.dataset.state = 'ready';
  widget.removeAttribute('hidden');
  widget.setAttribute('aria-label', `${roundedTemp} degrees Fahrenheit and ${config.label} near ${location}`);
}

function setWidgetErrorState(widget) {
  const temperature = widget.querySelector('.header-weather__temperature');
  const label = widget.querySelector('.header-weather__label');

  if (temperature) temperature.textContent = 'Weather unavailable';
  if (label) label.textContent = 'Bethlehem, PA';

  widget.dataset.state = 'error';
  widget.removeAttribute('hidden');
}

async function loadWeather(widget) {
  const latitude = widget.dataset.lat;
  const longitude = widget.dataset.lon;

  if (!latitude || !longitude) {
    setWidgetErrorState(widget);
    return;
  }

  widget.dataset.state = 'loading';

  try {
    const params = new URLSearchParams({
      latitude,
      longitude,
      current: 'temperature_2m,weather_code,is_day',
      temperature_unit: 'fahrenheit',
      timezone: 'America/New_York',
    });
    const response = await fetch(`${WEATHER_URL}?${params.toString()}`);

    if (!response.ok) throw new Error(`Weather request failed: ${response.status}`);

    const payload = await response.json();

    if (!payload?.current) throw new Error('Weather payload missing current conditions');

    updateWidget(widget, payload.current);
  } catch (error) {
    console.error(error);
    setWidgetErrorState(widget);
  }
}

onDocumentLoaded(() => {
  const widgets = document.querySelectorAll('[data-weather-widget]');

  widgets.forEach((widget) => {
    if (!(widget instanceof HTMLElement)) return;
    loadWeather(widget);
  });
});